module.exports = __webpack_public_path__ + "public/img/Menyusun Surat Perjanjian Bahasa Inggris bagi Calon Staf Legal.f3fea899.png";